/**
 *
 * Applies behaviors to the login modal for redirection
 *
 * @param {HTMLElement} document - The html document
 * @param {jQuery} $ - Global Context's jQuery
 * @param {Object} ebatesGlobal - Global Context's FE ebates object - of note: ebates.helpcenter.targetPage populated on .vm build
 */
!function( doc, $, ebatesGlobal ) {

    if ( ebatesGlobal.helpcenter && ebatesGlobal.helpcenter.loginPrompter ) {
        throw new Error('Attempting to load Login Prompter more than once');
    }
    ebatesGlobal.helpcenter = ebatesGlobal.helpcenter || {};

    // open over

    const loginLinkSelector = '#login-modal';
    const defaultLoginLinkSelector = '.show-join-overlay[data-click-action="Click Sign In"]';
    const defaultMWLoginLinkSelector = '[data-click-action="Click Sign In"]';
    const desktopVerifyModal = '/help/verify/member/modal.htm';
    const mwVerifyUrl = '/help/verify.do';
    const signInActionListeners = [];
    const ajaxAuthRedirects = true;  // Switch for whether or not ajax Auth Requests direct to a main page, or pop a modal on page
    let loginLink$;
    let requestLink$;
    let requestEvent;
    let currentTargetUrl = '';
    let prevSignInTargetUrl = '';
    let formRequestAdded = false;
    let formShown = false;
    let siSUformInterchange = false;

    const linkFilterCallbacks = [];
    const onLoadTargetPath = getValidTargetPath();

    const deleteTargetPageData = JSON.stringify({
        method: 'delete',
    });
    const targetPageRequestType = 'application/json';

    /**
     * Called in order to clean up a target page session attribute that is
     * valid for this login-prompter
     */
    function sanitizeTargetPageAttrs() {
        $.ajax('/help/v1/targetpage.do', {
            async: false,
            method: 'POST',
            data: deleteTargetPageData,
            contentType: targetPageRequestType,
            dataType: 'json',
            error: (xhr, status, errorThrown) => {
                console.error(`TargetPage Reset Failed: ${status}:${errorThrown}`);
            }
        });
    }

    function setTargetPage(targetPath) {
        let set = false;

        $.ajax('/help/v1/targetpage.do', {
            async: false,
            method: 'POST',
            data: JSON.stringify({
                method: 'post',
                body: {
                    targetpage: targetPath
                }
            }),
            contentType: targetPageRequestType,
            dataType: 'json',
            success: (response, status, xhr) => {
                if ( response.status === 'success') {
                    set = true;
                }
            },
            error: (xhr, status, errorThrown) => {
                console.error(`TargetPage Set Failed: ${status}:${errorThrown}`);
            }
        });

        return set;
    }

    function onLoadTargetPageMatchesCriteria(path, setBy) {
        if ( path.indexOf('/help/') === 0  && setBy === 'filter' || setBy === 'rest' ) {
            return true;
        }
        return false;
    }


    $(document).ready( () => {

        if ( onLoadTargetPath && currentPageCanOnLoadPrompt() ) {
            // Since the Target Path is a session variable, it may be from another tab
            const authObject = requiresAuth(onLoadTargetPath);
            if ( authObject ) {
                triggerLoginPrompt(onLoadTargetPath, null, authObject.authAction);
            }
        }

        // Link Guarding
        $('body').on('click', 'a', (e) => {
            const linkEl$ = $(e.currentTarget);
            if ( !isSignInLink(linkEl$) ) {
                applyFilterCallBacks(e, linkEl$);
                const linkURL = e.currentTarget.getAttribute('href');
                if (linkURL && !tryAuthPath(linkURL)) {
                    e.preventDefault();
                }
            }
        });

    });

    /**
     * Exists since velocity files use session attribute that may also fill in
     * .js resources etc.
     */
    function getValidTargetPath() {
        const onloadTargetPath = ebatesGlobal.helpcenter.targetPage && decodeURIComponent(ebatesGlobal.helpcenter.targetPage);
        if ( onLoadTargetPageMatchesCriteria(onloadTargetPath, ebatesGlobal.helpcenter.targetPageSetby) ) {
            return onloadTargetPath;
        }
        return null;
    }

    /**
     * Used particularly for things like sign-in pages that would not need to prompt the user
     */
    function currentPageCanOnLoadPrompt() {
        if ( window.location.pathname === mwVerifyUrl ) {
            return false;
        }
        return true;
    }


    function applyFilterCallBacks( e, linkEl$ ) {
        const linkURL = linkEl$.attr('href');
        if ( !ebatesGlobal.user.loggedIn && requiresAuth(linkURL)){
            linkFilterCallbacks.forEach((callbackObject)=> {
                if (callbackObject.isSelected(linkEl$)){
                    signInActionListeners.push(callbackObject.onClicked);
                }
            });
            requestLink$ = linkEl$;
            requestEvent = e;
        } else {
            linkFilterCallbacks.forEach( (callbackObject)=> {
                if ( callbackObject.isSelected(linkEl$) ) {
                    callbackObject.onClicked(e, linkEl$, 'noAction', null);
                }
            });
        }
    }

    /**
     * @callback SignInModalPoppedCallback
     * @param {jQuery Event} evt - The event that spawned the Auth Query and Modals
     * @param {jQuery Element} linkEl$ - The Link Element that spawned this `auth OR a representative link with href
     * @param {string} event token - success, closed, or noAction (the modal did not show up)
     * @param {Callback} done - a Callback that MUST be called to notify the finish of this function
     * @param {HTMLElement} [form] - the form element that was submitted (may be null if noaction or closed)
     * @param {Object} [response] - JSON response from submission success
     */

    /**
     * Adds a callback to be called when a given link is triggered
     * that is potentially AuthAware.
     *
     * This is meant for tracking that a link is actually passed through,
     * rather than clicked on and not signed-in
     *
     * @param {function(jQueryElement)} selectCallBack - returns true if the linkElement passed to it, should trigger the callback
     * @param {SignInModalPoppedCallback} actCallBack - the callback to be triggered if the selectCallback returns true
     */
    function addAuthAwareLinkCallBack( selectCallBack, actCallBack ) {
        linkFilterCallbacks.push( {
            isSelected: selectCallBack,
            onClicked: actCallBack
        });
    }

    function isSignInLink(linkEl$) {
        return linkEl$.is(loginLinkSelector) ||
            linkEl$.is(defaultLoginLinkSelector) ||
            linkEl$.is(defaultMWLoginLinkSelector);
    }

    function getSignInLink() {
        if ( !loginLink$ ) {
            //MW Hack since link is different
            if ( ebates.stats.device === 'M' ) {
                loginLink$ = $(defaultMWLoginLinkSelector);
            } else {
                let $loginLink = $(loginLinkSelector);
                if ($loginLink.length > 0) {
                    loginLink$ = $loginLink;
                } else {
                    $loginLink = $(defaultLoginLinkSelector);
                    if ($loginLink.length > 0) {
                        loginLink$ = $loginLink;
                    }
                }
            }
        }
        return loginLink$;
    }

    function clickSignInLinkDeskTop(targetPath) {
        const link$ = getSignInLink();
        if ( !link$ ) {
            throw new Error('No Sign In Link found');
        }
        formRequestAdded = true;
        prevSignInTargetUrl = link$.attr('data-target-url') || '';
        link$.attr('data-target-url', targetPath);
        currentTargetUrl = targetPath;
        link$.click();
    }

    function clickSignInLinkMW(targetPath) {
        const link$ = getSignInLink();
        if ( !link$ ) {
            throw new Error('No Sign In Link found');
        }
        formRequestAdded = true;
        prevSignInTargetUrl = link$.attr('href') || '';
        const newTargetUrl = ebatesGlobal.param.add('targetpage', targetPath, ebatesGlobal.param.remove('targetpage', prevSignInTargetUrl));
        link$.attr('href', newTargetUrl);
        currentTargetUrl = targetPath;
        //Trigger for global analytics listeners - acted on in Link Guard above
        link$.click();
        //Trigger submit success since redirect has no way of knowing
        onSignInSuccess(  null, null, null, ()=> {
            window.location.href = newTargetUrl;
        });
    }

    function clickSignInLink(targetPath) {
        if ( ebates.stats.device === 'M' ) {
            clickSignInLinkMW(targetPath);
        } else {
            clickSignInLinkDeskTop(targetPath);
        }
    }

    function openVerifyPrompt(targetPath) {
        if ( ebates.stats.device === 'M' ) {
            const verifyurl =  ebates.param.add('p', encodeURIComponent(targetPath), mwVerifyUrl);
            window.location.href = verifyurl;
        } else {
            formRequestAdded = true;
            ebatesGlobal.js.require(ebatesGlobal.src.modal, function() {
                const verifyurl =  ebates.param.add('p', encodeURIComponent(targetPath), desktopVerifyModal);
                ebatesGlobal.UI.modal('Loading...', {
                    url: verifyurl,
                    bg: {
                        scroll: true,
                        use: true,
                        classes: ['op3', 'hide'],
                        closeOnClick: false
                    }
                }, {
                    ajax: {
                        done: () => {
                            $('.eb-modal').removeClass('border-grn-t-5');
                        }
                    }
                });
            });
        }
    }

    /**
     * Triggers a Login for the user with a targetUrl to direct on
     * successful login
     * @param targetPath
     * @param {SignInModalPoppedCallback} callback
     */
    function triggerLoginPrompt(targetPath, callback, action) {
        callback && signInActionListeners.push(callback);
        if ( !formRequestAdded && !formShown ) {
            if ( action === 'verify' ) {
                openVerifyPrompt(targetPath);
            } else {
                clickSignInLink(targetPath, callback);
            }
        }
    }


    function onModalClose() {
        if ( !siSUformInterchange ) {
            signInActionListeners.forEach((listener) => {
                listener(requestEvent, requestLink$, 'closed');
            });
            signInActionListeners.length = 0;
            formRequestAdded = false;
            formShown = false;
            applyPreviousUrlToSignInLink();
        }
    }

    function applyPreviousUrlToSignInLink() {
        if ( loginLink$ ) {
            loginLink$.attr('data-target-url', prevSignInTargetUrl);
        }
    }

    function onSignInSuccess(evt, form, response, atEndCallback) {
        const numToBeDone = signInActionListeners.length;
        if ( numToBeDone > 0  ) {
            let numDones = 0;
            signInActionListeners.forEach((listener) => {
                let wasCalled = false;
                const doneCall = () => {
                    if ( !wasCalled ) {
                        wasCalled = true;
                        numDones++;
                        if ( numDones === numToBeDone ) {
                            applyPreviousUrlToSignInLink();
                            atEndCallback && atEndCallback();
                        }
                    }
                };
                listener(requestEvent, requestLink$, 'success', doneCall, form, response);

            });
        } else {
            applyPreviousUrlToSignInLink();
            atEndCallback && atEndCallback();
        }
        signInActionListeners.length = 0;
    }

    function onSignInFormDone(evt, form) {
        formShown = true;
        siSUformInterchange = false;
        if ( formRequestAdded ) {
            const formChangeLinks = $(ebates.UI.active.modal).find('.show-join-overlay');
            formChangeLinks.attr('data-target-url', currentTargetUrl);
            formChangeLinks.on('click', () => {
                siSUformInterchange = true;
            });
        }
    }

    /**
     * Alerts all previously registered listeners that sign-in is not needed
     * @param {SignInModalPoppedCallback} callback - A current callback if this is part of a try
     * @param {String} targetPath - The targetPath is this is triggered by Manually calling tryAuth
     */
    function signInNotNeeded( callback, targetPath) {
        //Create a semantic link for consistency
        const linkEl$ = loginLink$ || $(`<a href=${targetPath} />`);
        const evt = jQuery.Event('click');
        evt.currentTarget = linkEl$[0];
        evt.target = linkEl$[0];

        signInActionListeners.forEach( (listener) => {
            listener( evt, linkEl$, 'noAction', null );
        });
        signInActionListeners.length = 0;
        callback && callback(evt,  linkEl$, 'noAction', null);
    }

    /**
     *
     * @param {string} targetPath - whole url
     * @param {string} method - matches jquery ajax http method (Default: GET)
     * @return {authAction: {String}, verifyUrl: {String}} authAction - If there is an authAction
     */
    function requiresAuth(targetPath, method) {
        let authAction = null;
        if ( targetPath ) {

            if ( !method ) {
                method = 'GET';
            }

            // Note: this is expensive since GET only returns header on problems, waiting for exposed Endpoint
            $.ajax(targetPath, {
                async: false,
                method: method,
                cache: false,
                complete: (xhr, status) => {
                    const verifyUrl = xhr.getResponseHeader('VerifyMember');
                    if (verifyUrl) {
                        const responseBody = xhr.responseText && JSON.parse(xhr.responseText);
                        authAction = {
                            authAction: responseBody.authAction,
                            verifyUrl: verifyUrl
                        };
                    }
                }
            });

            // Hack since every failed inquiry will set the target page again in legacy
            if ( authAction ) {
                sanitizeTargetPageAttrs();
            }

        }

        return authAction;
    }

    /**
     * Tests a targetPath to see if it's Auth
     * Will prompt the user with a sign-in if the user must
     * @param {string} targetPath
     * @param {SignInModalPoppedCallback} callback - a callback to be called when either sign-in completes on a modal or it was not needed
     * @param {String} httpMethod - jquery http method for the target path (default: GET)
     * @return {boolean} true if no sign-on modals are being opened
     */
    function tryAuthPath(targetPath, callback, httpMethod) {
        if (targetPath) {
            const authObject = requiresAuth(targetPath, httpMethod);
            if (authObject) {
                triggerLoginPrompt(targetPath, callback, authObject.authAction);
                return false;
            } else {
                signInNotNeeded(callback);
            }
        }
        return true;
    }

    /**
     * Attempts an ajax call, and if it fails, redirects to the targetPath
     * @param ajaxOpts
     * @param targetPath
     * @returns {null|*|jQuery|boolean|{getAllResponseHeaders, abort, setRequestHeader, readyState, getResponseHeader, overrideMimeType}}
     */
    function ajaxAuthAware( ajaxOpts, targetPath ) {

        if ( ajaxOpts.url == null ){
            console.error('Cannot provide null ajax url');
        }

        if ( ajaxAuthRedirects ) {
            const authObject = requiresAuth(ajaxOpts.url, ajaxOpts.method || ajaxOpts.type );
            if ( authObject ) {
                if ( setTargetPage(targetPath || window.location.pathname) ) {
                    window.location.href = authObject.verifyUrl;
                } else {
                    // Fail over - reload the page, since it should have same auth
                    window.location.reload();
                }
            } else {
                // No Auth Needed proceed
                return $.ajax(ajaxOpts);
            }
        } else {
            if ( tryAuthPath(ajaxOpts, null, ajaxOpts.method || ajaxOpts.type) ) {
                return $.ajax(ajaxOpts);
            }
        }

        return null;

    }

    //Global Exports
    ebatesGlobal.helpcenter.loginPrompter = {
        ajaxAuthAware: ajaxAuthAware,
        tryAuthPath: tryAuthPath,
        requiresAuth: requiresAuth,
        addAuthAwareLinkCallBack: addAuthAwareLinkCallBack,
    };

    //Register for Modal Events
    $(document).on('modal-closed', onModalClose);
    $(document).on('auth-form-success', onSignInSuccess);
    $(document).on('auth-form-init-done', onSignInFormDone);

}(document, $, ebates);
